<template>
  <aha-modal @hide="hide()" title="Withdraw invitation">
    <div v-if="isTeamCreatedByAdmin">
      Withdrawing the invitation to <b>{{ invitation.invitedEmail }}</b> will free up 1 licence.
    </div>
    <div v-else>
      The person you invited (<b>{{ invitation.invitedEmail }}</b>)
      will no longer have access to join the team.
    </div>
    <template #action>
      <aha-button
        variant="danger"
        :disabled="isWithdrawing"
        @click="handleWithdrawInvitation()"
        icon-name="delete"
        :submitting="isWithdrawing"
        has-margin-right
      >
        <aha-spinner variant="white" class="mr-1" v-if="isWithdrawing" />
        Withdraw
      </aha-button>
      <aha-link @click="hide()">
        <span class="font-bold">Cancel</span>
      </aha-link>
    </template>
  </aha-modal>
</template>
<script>

// constants
import * as Sentry from '@sentry/vue'
import eventCategories from '@/constant/eventCategories'

import utils from '@/util'
import InvitationApi from '@/api/invitation'

export default {
  props: {
    invitation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isWithdrawing: false,
    }
  },
  computed: {
    isTeamCreatedByAdmin() {
      return this.$store.state.currentAccount.createdFrom !== 'presenter'
    },
  },
  created() {

  },
  methods: {
    async handleWithdrawInvitation() {
      this.isWithdrawing = true
      try {
        await InvitationApi.patchInvitation(this.invitation.id, {
          status: 'cancelled',
        })
        this.$emit('updateInvitations')
        this.$emit('hide')
        utils.showToastSuccess(this.$i18nPresenter.t('Withdraw invitation successfully'))
        utils.mixpanelTracking(
          eventCategories.MY_TEAM,
          'Team Management > Cancel pending invitation > Cancel succeeded',
          this.invitation.invitedEmail,
          '',
          {
            plan: this.$store.state.currentUser.plan,
            isSelfCreatedTeam: this.$store.state.currentAccount.createdFrom === 'presenter',
          },
        )
      } catch (error) {
        utils.showToastError(this.$i18nPresenter.t('Withdraw invitation failed'))
        utils.mixpanelTracking(
          eventCategories.MY_TEAM,
          'Team Management > Cancel pending invitation > Cancel failed',
        )
        Sentry.captureException(error)
      } finally {
        this.isWithdrawing = false
      }
    },
    hide() {
      utils.mixpanelTracking(
        eventCategories.MY_TEAM,
        'Team management > Invite member > Withdraw invitation > Cancel',
        this.invitation.invitedEmail,
        '',
        {
          plan: this.$store.state.currentUser.plan,
          isSelfCreatedTeam: this.$store.state.currentAccount.createdFrom === 'presenter',
        },
      )
      this.$emit('hide')
    },
  },
}
</script>
